import styled from "styled-components";
import sns01 from "../img/sns/sns.png";

const Wrapper = styled.div`
  max-width : 900px;  
  margin: auto;
  position: relative; 
`;
const TopContainer = styled.div`
  margin-top: 5vh;
  display: flex;
  flex-wrap: wrap;  
  @media screen and (max-width:500px) {        
   margin-left: 1vw;   
  } 
`;
const ProductImg = styled.div`
  width: 50%;
  height: 100%;  
  display: flex;
  @media screen and (max-width:500px) {
    width: 100%;
    height: 60%;    
  }
`;
const Img = styled.div`
  width: 360px;
  height: 360px;
  background-image: url(${sns01});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  margin: auto;
  justify-content: center;
  align-items: center;
  @media screen and (max-width:500px) {
    width: 250px;
    height: 250px;    
  } 
`;
const Overview = styled.div`
  width: 50%;  
  padding: 0 1vw; 
  @media screen and (max-width:500px) {
    flex: 0 1 100%;
    padding: 1vh 0;
    height: 40%;    
  }
`;
const Title = styled.h1`
  font-size: 2.2rem;
  line-height: 1.3;
  @media screen and (max-width:500px) {
    font-size: 1.5rem;
    text-align: center;
    padding: 1vh 0;
  }
`;
const SubTitle = styled.h2`
  font-size: 1.6rem;
  line-height: 1.5;
  margin-bottom: 1.5vh;
  @media screen and (max-width:500px) {
    font-size: 1.3rem;
    margin-bottom: 1vh;
    text-align: center;
  }
`;
const Price = styled.p`
  font-size: 2rem;    
  color: #e23e3e;
  padding: 1vh 0;
  @media screen and (max-width:500px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;
const UnitText = styled.p`  
  @media screen and (max-width:500px) {    
    text-align: center;
  }
`;
const PayBtn = styled.div`
  width: 300px;
  height: 45px;
  background-color: #f8bfbf;
  border-radius: 5px;
  margin: 5vh 0;
  position: relative ;  
  a {
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
    font-size: 1.2rem;
    text-align: center;    
  }
  &:hover {
    box-shadow: 1px 3px 5px rgb(0, 0, 0, 0.3);
  }
  @media screen and (max-width:500px) {
    width: 150px;
    height: 35px;
    left: 0;
    right: 0;
    bottom: 20%;
    margin: 3vh auto;
    a { font-size: 1.1rem; }
  }
`;
const BottomContainer = styled.div`   
`;
const DescContainer = styled.div`
  width: 90%;    
  margin: 5vh auto;    
`;
const Desc = styled.div`
  padding-left: 3vw;
  margin-top: 5vh;
  p {
    line-height: 1.5;
  }
  @media screen and (max-width:500px) {
    p {
      max-width: 330px;            
    }
  } 
`;
const DescTitle = styled(SubTitle)`
  font-size: 2rem;
  @media screen and (max-width:500px) {
    font-size: 1.3rem;
  }
`;

function DetailSNS01() {
  return (
    <Wrapper>              
      <TopContainer>
        <ProductImg>
          <Img></Img>
        </ProductImg>
        <Overview>
          <Title>SNS 제작 및 업로드 관리</Title>
          <SubTitle>
            인스타그램 /페이스북/ 카카오 채널 중 택1            
          </SubTitle>
          <Price>330,000원</Price>
          <UnitText>(1건 단위)</UnitText>
          <PayBtn>
            <a href="https://link.payple.kr/NzU6MTY0Mzg2ODY3MA" target="blank" rel="noreferrer noopener">결제하기</a>
          </PayBtn>
        </Overview>
      </TopContainer>
      <BottomContainer>
        <DescContainer>          
          <Desc>
            <DescTitle>상품 소개</DescTitle>
            <p>인스타그램, 페이스북, 카카오 채널</p>
            <p>채널 개설 및 디자인 및 검색 엔진 최적화를 위한 세부적인 설정</p>
            <p>※ 1건 단위 각각 최소 330,000원부터‌</p>            
            <p>&nbsp;</p>                     
            <p>● 실사 위주 추천 : 인스타그램</p>
            <p>● 실사 + 일러스트 조합 추천 : 페이스북</p>
            <p>● 쿠폰 및 채팅 위주 추천 : 카카오 채널</p>
          </Desc>          
          <Desc>
            <DescTitle>주문 전 확인 사항</DescTitle>
            <p>※ SNS 1건당 최소 단가 기준 적용 금액이며, 품질 및 수량에 따라 가격은 조정됩니다.</p>
            <p>※ 상기된 가격은 부가세 포함입니다.</p> 
            <p>※ 모든 포스팅은 텍스트 혹은 이미지 형태로만 제공됩니다.</p>            
            <p>※ ‌규모에 따라 작업 기간은 제작 5일, 포스팅 2일 이내 소요</p>            
            <p>※ 작업 완료 후 1주일 이내 결과 보고 발송</p>            
          </Desc>
        </DescContainer>
      </BottomContainer>
    </Wrapper>
  );
}

export default DetailSNS01;